"use strict";

import "./StayCard.css";
import React from "react";
import classnames from "classnames";
import lang from "vwa/lang";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";
import Button from "vwa/components/Button";

export default class StayCard extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			expanded: false
		};
	}
	
	toggle() {
		this.setState({
			expanded: !this.state.expanded
		});
	}
	
	handleAddressClick(evt, time) {
		evt.stopPropagation();
		this.props.onAddressClick(time);
	}
	
	handleDataClick(evt, which) {
		evt.stopPropagation();
		this.props.onFixData(which)
	}
	
	isDisplayedData(which) {
		return this.props.fixedData.includes(which) || this.state.expanded;
	}
	
	areDisplayedAnyData() {
		return this.props.fixedData.length > 0;
	}
	
	isBodyShown() {
		return this.state.expanded || this.areDisplayedAnyData()
	}
	
	getRowDataClassName(which) {
		return classnames(
			{"Hidden": !this.isDisplayedData(which)},
			{"Fixed": this.props.fixedData.includes(which)}
		);
	}
	
	renderCardHeader() {
		return (
			<header>
				<h1 className="POIName">{this.props.section.poi}</h1>
				<div className="Summary">
					<div className="TimeAndAddress">
						<div>
							<div>{this.props.section.start.time.toLocaleString()}</div>
							<div>
								{this.props.section.start.truncated ? (<label className="Indicator">{lang.ALREADY_IN_POI}</label>) : null }
								<label
									className="Address"
									onMouseOver={evt => this.props.onAddressMouseOver(this.props.section.start.timeStamp)}
									onMouseLeave={evt => this.props.onAddressMouseLeave(this.props.section.start.timeStamp)}
									onClick={evt => this.handleAddressClick(evt, this.props.section.start.timeStamp)}
								>{this.props.section.start.address}</label>
							</div>
						</div>
						<div>
							<div>{this.props.section.end.time.toLocaleString()}</div>
							<div>
								{this.props.section.end.truncated ? (<label className="Indicator">{lang.STILL_IN_POI}</label>) : null }
								<label
									className="Address"
									onMouseOver={evt => this.props.onAddressMouseOver(this.props.section.end.timeStamp)}
									onMouseLeave={evt => this.props.onAddressMouseLeave(this.props.section.end.timeStamp)}
									onClick={evt => this.handleAddressClick(evt, this.props.section.end.timeStamp)}
								>{this.props.section.end.address}</label>
							</div>
						</div>
					</div>
					<div className="DistanceAndTimeDiff">
						<label>{this.props.section.totalVehicleDistanceDiff} / {this.props.section.timeDiff}</label>
						<Button 
							icon="chart-bar"
							onClick={evt => this.props.onGetActivity(this.props.section.start.timeStamp, this.props.section.end.timeStamp)}
						/>
					</div>
				</div>
			</header>
		);
	}
	
	renderCardBody() {
		return (
			<table className={classnames({"Hidden": !this.isBodyShown()})}>
				<tbody>
					<tr className={this.getRowDataClassName("totalVehicleDistance")}>
						<td
							title={lang.CLICK_HERE_TO_FIX_IT}
							onClick={evt => this.handleDataClick(evt, "totalVehicleDistance")}
						>{lang.TOTAL_VEHICLE_DISTANCE}</td>
						<td>{this.props.section.start.totalVehicleDistance}</td>
						<td> &#8594; </td>
						<td>{this.props.section.end.totalVehicleDistance}</td>
					</tr>
					<tr className={this.getRowDataClassName("avgSpeed")}>
						<td
							title={lang.CLICK_HERE_TO_FIX_IT}
							onClick={evt => this.handleDataClick(evt, "avgSpeed")}
						>{lang.AVERAGE_SPEED}</td>
						<td>{this.props.section.avgSpeed}</td>
					</tr>
					<tr className={this.getRowDataClassName("maxSpeed")}>
						<td
							title={lang.CLICK_HERE_TO_FIX_IT}
							onClick={evt => this.handleDataClick(evt, "maxSpeed")}
						>{lang.MAXIMUM_SPEED}</td>
						<td>{this.props.section.maxSpeed}</td>
					</tr>
					<tr className={this.getRowDataClassName("starts")}>
						<td
							title={lang.CLICK_HERE_TO_FIX_IT}
							onClick={evt => this.handleDataClick(evt, "starts")}
						>{lang.NUMBER_OF_STARTS}</td>
						<td>{this.props.section.starts}</td>
					</tr>
					<tr className={this.getRowDataClassName("stops")}>
						<td
							title={lang.CLICK_HERE_TO_FIX_IT}
							onClick={evt => this.handleDataClick(evt, "stops")}
						>{lang.NUMBER_OF_STOPS}</td>
						<td>{this.props.section.stops}</td>
					</tr>
				</tbody>
			</table>
		);
	}
	
	renderCardFooter() {
		return (
			<footer
				onClick={evt => {evt.stopPropagation(); this.toggle();}}
			>
				&bull;&bull;&bull;
			</footer>
		);
	}
	
	render() {
		return (
			<Card
				className="StayCard"
				onClick={() => this.props.onClick()}
			>
				{this.renderCardHeader()}
				{this.renderCardBody()}
				{this.renderCardFooter()}
			</Card>
		);
	}
	
}

StayCard.propTypes = {
	section:			React.PropTypes.object,
	fixedData:			React.PropTypes.arrayOf(React.PropTypes.string),
	onClick:			React.PropTypes.func,
	onAddressMouseOver:	React.PropTypes.func,
	onAddressClick:		React.PropTypes.func,
	onFixData:			React.PropTypes.func
};

StayCard.defaultProps = {
	section:			null,
	fixedData:			[],
	onClick:			() => {},
	onAddressMouseOver: corssingTime => {},
	onAddressClick:		crossingTime => {},
	onFixData:			which => {}
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossingsStays/StayCard/StayCard.jsx